export default "__VITE_ASSET__BWMsj7MT__"